import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { CalendarDays, Clock } from "lucide-react";
import { Button } from "../ui/button";
import { toast } from "sonner";

function appointmentLabel(item) {
  return (
    item?.paciente_nombre ||
    item?.patient_name ||
    item?.nombre ||
    item?.label ||
    "Paciente"
  );
}

export default function TodayAgendaCard({
  today = [],
  upcoming = [],
  showcaseMode = false,
  loading = false,
  unavailable = false,
  unavailableMessage = "",
}) {
  const todayList = Array.isArray(today) ? today : [];
  const upcomingList = Array.isArray(upcoming) ? upcoming : [];
  const next = todayList[0] || upcomingList[0] || null;

  return (
    <Card className="border-slate-200 shadow-sm" data-testid="dashboard-visual-agenda">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg text-slate-900">
          <CalendarDays className="h-5 w-5 text-sky-700" />
          Agenda de hoy
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {loading ? (
          <div className="h-20 animate-pulse rounded-xl bg-slate-100" aria-busy="true" />
        ) : unavailable ? (
          <p className="text-sm text-slate-600" data-testid="dashboard-visual-agenda-unavailable">
            {unavailableMessage || "La Agenda está temporalmente no disponible."}
          </p>
        ) : next ? (
          <div className="rounded-xl border border-sky-100 bg-sky-50/70 p-3" data-testid="dashboard-visual-next-appointment">
            <p className="text-xs font-medium uppercase tracking-wide text-sky-800">Próxima cita</p>
            <p className="mt-1 font-medium text-slate-900">{appointmentLabel(next)}</p>
            <p className="text-sm text-slate-600">
              {[next.hora, next.motivo].filter(Boolean).join(" · ") || "Horario por confirmar"}
            </p>
          </div>
        ) : (
          <p className="text-sm text-slate-600" data-testid="dashboard-visual-agenda-empty">
            No hay citas programadas para hoy. Cuando existan, aparecerán aquí.
          </p>
        )}

        {!loading && !unavailable && todayList.length > 0 ? (
          <ul className="space-y-2">
            {todayList.map((item, index) => (
              <li
                key={item.id || `apt-${index}`}
                className="flex items-center justify-between gap-3 rounded-lg border border-slate-100 bg-slate-50 px-3 py-2"
              >
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-slate-900">{appointmentLabel(item)}</p>
                  <p className="text-xs text-slate-500">{item.motivo || "Consulta"}</p>
                </div>
                <span className="inline-flex shrink-0 items-center gap-1 text-xs text-slate-600">
                  <Clock className="h-3.5 w-3.5" />
                  {item.hora || "—"}
                </span>
              </li>
            ))}
          </ul>
        ) : null}

        {showcaseMode ? (
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="border-slate-200"
            onClick={() => toast.info("Disponible en la plataforma autenticada.")}
          >
            Ver agenda
          </Button>
        ) : (
          <Button asChild variant="outline" size="sm" className="border-slate-200">
            <Link to="/agenda">Ver agenda</Link>
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
